var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { BLUE_500, Card, getTestId, IconButton } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getWithFilterAction } from './WithFilterActionWidgetStyles';
import { DropdownFilter } from './dropdown-filter/DropdownFilter';
export var withFilterAction = Component => {
  var Wrapper = props => {
    var _props$withFilterActi = props.withFilterAction,
      withFilterAction = _props$withFilterActi === void 0 ? false : _props$withFilterActi,
      _props$withFilterActi2 = props.withFilterActionProps,
      withFilterActionProps = _props$withFilterActi2 === void 0 ? {} : _props$withFilterActi2,
      restProps = __rest(props, ["withFilterAction", "withFilterActionProps"]);
    var _useState = useState(false),
      filterOpenState = _useState[0],
      setFilterOpenState = _useState[1];
    var style = getWithFilterAction();
    var _withFilterActionProp = withFilterActionProps.id,
      id = _withFilterActionProp === void 0 ? 'QuickFilterChange' : _withFilterActionProp,
      onQuickFilterChangeMetaData = withFilterActionProps.onQuickFilterChangeMetaData,
      quickFilterActionList = withFilterActionProps.quickFilterActionList,
      _withFilterActionProp2 = withFilterActionProps.isRadioBoxFilter,
      isRadioBoxFilter = _withFilterActionProp2 === void 0 ? false : _withFilterActionProp2;
    var onQuickFilterChangeHandler = data => {
      var _a, _b;
      var radioFilteredLabel = {};
      if (isRadioBoxFilter) {
        var filteredValue = (_a = data === null || data === void 0 ? void 0 : data.filterList) === null || _a === void 0 ? void 0 : _a.filter(item => item === null || item === void 0 ? void 0 : item.checked);
        if ((filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) > 0) {
          radioFilteredLabel = filteredValue[0];
          data = Object.assign(Object.assign({}, data), radioFilteredLabel);
        }
      }
      onQuickFilterChangeMetaData && ((_b = restProps.onUserAction) === null || _b === void 0 ? void 0 : _b.call(restProps, Object.assign({
        id
      }, onQuickFilterChangeMetaData), Object.assign(Object.assign({}, restProps), {
        data
      })));
    };
    var innerComponent = () => {
      return _jsxs(Card, Object.assign({}, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'withFilterAction'), {
        children: [_jsx(View, Object.assign({
          style: style.filterWrapper
        }, {
          children: _jsx(IconButton, {
            onPress: () => setFilterOpenState(!filterOpenState),
            noBgColor: true,
            iconProps: {
              color: BLUE_500
            },
            type: "secondary",
            iconName: "FilterIcon",
            testID: "icon-button"
          })
        })), _jsx(Component, Object.assign({}, restProps, {
          onUserAction: restProps.onUserAction
        })), filterOpenState && _jsx(DropdownFilter, {
          onQuickFilterChange: data => onQuickFilterChangeHandler(data),
          isRadioBoxFilter: isRadioBoxFilter,
          quickFilterList: quickFilterActionList,
          showDropdown: true,
          isFilterEnable: true,
          style: {
            position: 'absolute',
            top: 50,
            right: 5
          },
          setShowDropdown: () => setFilterOpenState(!filterOpenState),
          testID: "drop-down-filter"
        })]
      }));
    };
    return _jsx(_Fragment, {
      children: withFilterAction ? innerComponent() : _jsx(Component, Object.assign({}, restProps, {
        onUserAction: restProps.onUserAction
      }))
    });
  };
  return Wrapper;
};